/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_EventsInputs */

const en_fw_notify_events = /** @type {(inputs: Fw_Notify_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const id_fw_notify_events = /** @type {(inputs: Fw_Notify_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kejadian`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Fw_Notify_EventsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_events = /** @type {((inputs?: Fw_Notify_EventsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_EventsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_events(inputs)
	return en_fw_notify_events(inputs)
});